import { c as _c } from "react/compiler-runtime";
import { IcoBuilding16, IcoCake16, IcoEmail16, IcoFileText16, IcoFileText216, IcoInfo16, IcoPhone16, IcoStore16, IcoUser16, IcoUsers16 } from '@onefootprint/icons';
import { MatchSignalAttribute } from '@onefootprint/types/src/data/match-signal-attribute';
type ValidationTimelineItemIconProps = {
  attribute: string;
};
const ValidationTimelineItemIcon = t0 => {
  const $ = _c(10);
  const {
    attribute
  } = t0;
  if (attribute === MatchSignalAttribute.name) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <IcoUser16 />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  if (attribute === MatchSignalAttribute.email) {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <IcoEmail16 />;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  if (attribute === MatchSignalAttribute.phone || attribute === MatchSignalAttribute.businessPhoneNumber) {
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <IcoPhone16 />;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    return t1;
  }
  if (attribute === MatchSignalAttribute.address || attribute === MatchSignalAttribute.businessAddress) {
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <IcoBuilding16 />;
      $[3] = t1;
    } else {
      t1 = $[3];
    }
    return t1;
  }
  if (attribute === MatchSignalAttribute.dob) {
    let t1;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <IcoCake16 />;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    return t1;
  }
  if (attribute === MatchSignalAttribute.ssn) {
    let t1;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <IcoFileText216 />;
      $[5] = t1;
    } else {
      t1 = $[5];
    }
    return t1;
  }
  if (attribute === MatchSignalAttribute.document) {
    let t1;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <IcoFileText16 />;
      $[6] = t1;
    } else {
      t1 = $[6];
    }
    return t1;
  }
  if (attribute === MatchSignalAttribute.businessName) {
    let t1;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <IcoStore16 />;
      $[7] = t1;
    } else {
      t1 = $[7];
    }
    return t1;
  }
  if (attribute === MatchSignalAttribute.businessTIN) {
    let t1;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <IcoInfo16 />;
      $[8] = t1;
    } else {
      t1 = $[8];
    }
    return t1;
  }
  if (attribute === MatchSignalAttribute.businessBeneficialOwners) {
    let t1;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <IcoUsers16 />;
      $[9] = t1;
    } else {
      t1 = $[9];
    }
    return t1;
  }
  return null;
};
export default ValidationTimelineItemIcon;